
export const headerData = {
    name: 'Hannan Shehzad',
    title: "Hello! I am",
    desciption: "I am Abdul Hannan Shehzad, a proficient programmer driven by a passion for continuous learning and innovation. My adeptness at grasping new technologies quickly, coupled with my problem-solving acumen, positions me as an asset in dynamic environments. I am actively seeking opportunities to contribute my expertise to impactful projects. Your consideration is greatly appreciated, I look forward to the chance to bring my dedication and skills to your team.",
    image: 'https://i.ibb.co/zP2bw4q/6-Snapchat-17794545842.jpg',
    imagebw: 'https://i.ibb.co/MNKv7mx/6-Snapchat-17794545842bw.jpg',
    resumePdf: 'https://drive.google.com/file/d/10jFAh789FOAtzj8NmABHDgXn2ll5pZc8/view?usp=sharing'
}
